import React from 'react';

import CommonImage from '../../../../components/CommonImage';

const SopModal = () => {
	return (
		<div className="popup-wrapper sop-modal">
			<div className="common-popup sop-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Journey SOP & tutorials</h3>
					</div>
					<div className="close-btn">
						<CommonImage alt="close" src=" /icons/close.svg" />
					</div>
				</div>
				<div className="common-popup-body pb-0">
					<div className="sop-content-section">
						<div className="single-sop-card">
							<h4 className="semibold-14 mb-1">Which styles are you seeing here:</h4>
							<p className="regular-14 mb-3">Details here</p>
						</div>
						<div className="single-sop-card">
							<h4 className="semibold-14 mb-1">Metabase report link:</h4>
							<ul className="sop-list mb-3">
								<li className="regular-14 blue cursor-pointer ml-3">
									<p>Click here to view the report</p>
								</li>
							</ul>
						</div>
						<div className="single-sop-card">
							<h4 className="semibold-14 mb-1">Summary SOP:</h4>
							<p className="regular-14 mb-3">Here is the summary SOP</p>
						</div>
						<div className="single-sop-card">
							<h4 className="semibold-14 mb-1">Details SOP:</h4>
							<ul className="sop-list mb-3">
								<li className="regular-14 blue cursor-pointer ml-3">
									<p>Details SOP</p>
								</li>
							</ul>
						</div>
						<div className="single-sop-card">
							<h4 className="semibold-14 mb-1">Tutorial link:</h4>
							<ul className="sop-list mb-3">
								<li className="regular-14 blue cursor-pointer ml-3">
									<p>Here is the tutorials link 1</p>
								</li>
								<li className="regular-14 blue cursor-pointer ml-3">
									<p>Here is the tutorials link 1</p>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="modal-footer d-block ">
					<div className="footer-buttons text-left">
						<ul className="sop-list mb-0">
							<li className="regular-14 blue cursor-pointer text-underline">
								<p>Edit SOP</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SopModal;
